import React from 'react';

export default function Title({ value }) {
  return <h2 className="text-2xl my-4 text-center px-4">{value}</h2>;
}
